<template>
	<Loader v-if="loading" />
	<div v-else class="content">
		<Loader :soft="true" v-if="saving" />
		<div class="flex">
			<h1>Purchase orders</h1>
			<div class="flex-grow text-right">
				<button :disabled="saving" v-on:click="discover()">Discover in Uniconta</button>
			</div>
		</div>

		<div class="margin-top">
			<Table :columns="columns" :rows="rows" />
		</div>
	</div>
</template>

<script>
import Vue from 'vue'

export default {
  data: () => ({
    loading: false,
    saving: false,
    records: [],
    columns: {
      purchase_order: {
				  name: 'id'
      },
      reference_1: {
        name: 'Ref 1'
      },
      reference_2: {
        name: 'Ref 2'
      },
      delivery_date: {
        name: 'Delivery date'
      },
      inbound_date: {
        name: 'Inbound date'
      },
      last_synced_at: {
        name: 'Last updated from warehouse'
      },
      closed_at: {
        name: 'Closed at'
      },
      processing: {
        name: 'Progress'
      }
    }
  }),
  computed: {
    rows () {
      return this.records.map(row => {
        row.purchase_order = {
          type: 'link',
          title: row.id,
          url: '/#/purchase-order/' + row.id
        }

        return row
      })
    }
  },
  methods: {
    load () {
      Vue.$api.get('/purchase-orders', {}, {
        before: () => this.loading = true,
        always: () => this.loading = false,
        callback: data => this.parse(data)
      })
    },
    parse (data) {
      this.records = data.map(row => {
        row.processing = {
          type: 'progress',
          progress: row.progress[0],
          total: row.progress[1]
        }

        return row
      })
    },
    execute (url) {
      Vue.$api.post(url, {}, {
        before: () => this.saving = true,
        always: () => this.saving = false,
        callback: data => this.load()
      })
    },
    discover () {
      this.execute('/purchase-orders/discover')
    },
    gotToDetails (row) {
      this.$router.push({
        path: '/purchase-order/' + row.id
      })
    },
    gotToPartials (row) {
      this.$router.push({
        path: '/purchase-order/' + row.id + '/partials'
      })
    },
    refresh (row) {
      this.execute('/purchase-order/' + row.id + '/refresh')
    },
    pushToFtp (row) {
      this.execute('/purchase-order/' + row.id + '/push-to-ftp')
    }
  },
  created () {
    this.load()
  }
}
</script>
